export default __webpack_public_path__ + "static/media/BET365-logo.dc5eb16b.png";